<template>
  <div class="vue-table">
    <template v-if="checkApi(tableData.api) && tableData.search">
      <el-form :model="tableData.search" label-width="auto" inline size="small">
        <slot name="searchBar" :doSearch="doSearch"></slot>
        <el-form-item>
          <el-button type="primary" @click="doSearch">查询</el-button>
          <el-button @click="doReset">重置</el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-row type="flex" align="bottom" justify="space-between" class="table-toolbar">
      <statistics :count-list="customCountList || countList"/>
      <div class="toolbar-right">
        <span class="operate-bar"><slot name="operateBar"></slot></span>
        <el-button v-if="!hideSetting" class="icon-btn" type="text" @click="showTableSet">
          <i class="el-icon-setting"></i>
        </el-button>
        <el-button v-if="checkApi(tableData.api)" class="icon-btn refresh-btn" type="text" @click="refresh">
          <i class="el-icon-refresh"></i>
        </el-button>
      </div>
    </el-row>
    <el-table :data="displayList" :row-key="getRowKeys" :expand-row-keys="expands" :size="size" :span-method="spanMethod" @cell-dblclick="cellDblClick" :border="border"
              @selection-change="selectionChange" @expand-change="expandChange" v-loading="loading" :empty-text="checkApi(tableData.api) ? '暂无数据' : '无数据权限，请联系管理员'">
      <!--多选-->
      <el-table-column width="45" type="selection" v-if="tableData.isMultiple" align="center"></el-table-column>
      <!--序号-->
      <slot name="index" :currentPage="pagingData.currentPage" :pageSize="pagingData.pageSize"></slot>
      <!--列表项-->
      <template v-for="(item, index) in tableData.tableColumn">
        <el-table-column :key="index" :label="item.label" :width="item.width" :min-width="Math.max(item.minWidth || 0, flexWidth(item))"
                         :align="item.position || 'left'" :show-overflow-tooltip="'tooltip' in item ? item.tooltip : true">
          <template slot="header" v-if="item.tips">
            <el-tooltip effect="dark" placement="top-start">
              <el-button class="tips" icon="el-icon-info">{{item.label}}</el-button>
              <template slot="content">
                <div v-html="item.tips" class="content"></div>
              </template>
            </el-tooltip>
          </template>
          <template slot-scope="{row, column}">
            <slot :name="item.property" :row="row" :col="column">
              <span v-html="showTableData(item.property, row, item.format)"></span>
            </slot>
          </template>
        </el-table-column>
      </template>
      <!--展开项-->
      <el-table-column type="expand" v-if="tableData.hasExpand" label="更多" width="55">
        <template slot-scope="{row}">
          <el-form label-position="left" class="table-expand" :label-width="tableData.expandLabelWidth + 'px'">
            <el-row :gutter="20">
              <template v-for="(item, index) in tableData.expandColumn">
                <el-col :span="12" :key="index">
                  <el-form-item :label="item.label" >
                    <span v-if="item.formatFun" :title="item.formatFun(row)">{{item.formatFun(row)}}</span>
                    <span v-else v-html="showTableData(item.property, row, item.format)" :title="showTableData(item.property, row, removeColor(item.format))"></span>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <!--      操作栏-->
      <slot name="actionBar"></slot>
    </el-table>
    <vue-pagination :paging-data="pagingData" @getData="handlePaging"/>
    <table-column-set v-if="tableColumnSet.visible" :dialog-data="tableColumnSet" @finish="getTableColumn"/>
  </div>
</template>

<script>
import Statistics from "@view/components/Statistics"
import TableColumnSet from "./dialog/TableColumnSet"
import {cancelRequest} from "@/axios/cancel";
export default {
  name: "vueTable",
  components: {Statistics,TableColumnSet},
  props: {
    size: {
      type: String,
      default: "",
    },
    tableData: Object,
    selectList: Array,
    spanMethod: Function,
    customCountList: Array,
    pageSize: Number,
    pageList: Array,
    border: Boolean,
    hideSetting: Boolean,
    // 是否开启前端（本地）自动分页：开启后监听 tableData.tableList 的变化，由组件自行分页，翻页不再请求接口
    autoPaging: Boolean,
  },
  data() {
    return {
      expands: [],
      // 自动分页时的全量数据（tableData.tableList 始终保存全量，避免切片后数据丢失）
      allList: [],
      tableColumnSet: {title: "自定义列表字段", visible: false, columnList: [], checkedList: [], api: this.tableData.api},
      columnList: JSON.parse(JSON.stringify(this.tableData.tableColumn.filter(item => !item.hidden))),
      pagingData: {
        total: 0,
        pageSize: this.pageSize || 10,
        pageList: this.pageList || [10, 20, 50, 100],
        currentPage: 1,
      },
      countList: [
        {name: "总记录", count: 0},
      ],
      loading: false,
      searchCommit: {}
    }
  },
  computed: {
    // 表格实际渲染的数据：非自动分页时透传，自动分页时取当前页切片
    displayList() {
      if (!this.autoPaging) return this.tableData.tableList;
      const {currentPage, pageSize} = this.pagingData;
      const start = (currentPage - 1) * pageSize;
      return this.allList.slice(start, start + pageSize);
    }
  },
  watch: {
    // 监听数据源变化，重算总条数并纠正页码
    "tableData.tableList": {
      handler(list) {
        if (!this.autoPaging) return;
        // 引用变化（整体替换/查询赋值）视为新数据源，回到第一页；
        // 同一数组的变异操作（push/splice 等）保留当前页，仅做越界纠正
        const isReplace = list !== this.allList;
        this.allList = Array.isArray(list) ? list : [];
        this.pagingData.total = this.allList.length;
        this.countList[0].count = this.allList.length;
        const maxPage = Math.max(1, Math.ceil(this.allList.length / this.pagingData.pageSize));
        if (isReplace) {
          this.pagingData.currentPage = 1;
          this.expands = [];
        } else if (this.pagingData.currentPage > maxPage) {
          this.pagingData.currentPage = maxPage;
        }
      },
      immediate: true
    },
    // 运行中动态切换开关时同步状态
    autoPaging(val) {
      this.pagingData.currentPage = 1;
      if (val) {
        this.allList = Array.isArray(this.tableData.tableList) ? this.tableData.tableList : [];
        this.pagingData.total = this.allList.length;
        this.countList[0].count = this.allList.length;
      } else {
        this.allList = [];
        // 交回后端分页，需要重新拉一次数据以校正总条数
        this.$nextTick(() => {
          this.$el && this.tableData.api && this.loadTable();
        });
      }
    }
  },
  created() {
    this.getTableColumn();
  },
  mounted() {
    this.getData();
  },
  methods: {
    cellDblClick(row, column, cell, event) {
      const val = event.target.innerText;
      this.copyText(val);
    },
    doSearch() {
      this.pagingData.currentPage = 1;
      this.loadTable();
    },
    doReset() {
      Object.keys(this.tableData.search).forEach(key => this.tableData.search[key] = "");
      this.$emit("searchReset");
      this.doSearch();
    },
    refresh() {
      if (this.tableData.search) {
        Object.keys(this.tableData.search).forEach(key => this.tableData.search[key] = "");
        this.copyObjValue(this.tableData.search, this.searchCommit);
      }
      this.loadTable();
    },
    // 分页组件事件：自动分页时只切换本地切片，不请求接口
    handlePaging() {
      if (this.autoPaging) {
        const maxPage = Math.max(1, Math.ceil(this.allList.length / this.pagingData.pageSize));
        if (this.pagingData.currentPage > maxPage) this.pagingData.currentPage = maxPage;
        this.expands = [];
        this.$emit("pageChange", {currentPage: this.pagingData.currentPage, pageSize: this.pagingData.pageSize});
        return;
      }
      this.refresh();
    },
    async loadTable() {
      this.loading = true;
      await this.getData(true);
      this.loading = false;
    },
    async getData(VUE_CLOSE_LOADING) {
      if (!this.tableData.api || !this.checkApi(this.tableData.api)) return false;
      let params = {VUE_CLOSE_LOADING};
      params.page = this.pagingData.currentPage;
      params.limit = this.pagingData.pageSize;
      this.tableData.timeSearch && this.copyObjValue(params, this.tableData.timeSearch);
      this.tableData.params && this.copyObjValue(params, this.tableData.params);
      this.sortBy && (params.orderby = this.sortBy);
      let search = {}
      this.tableData.search && this.copyObjValue(search, this.tableData.search);
      this.searchCommit = {...search};
      const hasLocation = this.tableData.tableColumn.find(item => item.property === "location");
      hasLocation && (search.location = true);
      Object.keys(search).forEach(key => /cond_(.*)/ig.test(key) && !search[RegExp.$1] && delete search[key]);
      cancelRequest(this.tableData.api);
      let res = await this.$Http[this.tableData.api]({...params, ...search});
      if (res?.data) {
        const list = res.data.list || [];
        // 自动分页以全量列表长度作为总数，兼容接口不返回 total 的情况
        const total = this.autoPaging ? list.length : (+res.data.total || 0);
        this.countList[0].count = total;
        this.pagingData.total = total;
        this.tableData.tableList = list;
        this.$emit("finish", res.data, search);
      }
    },
    flexWidth(row) {
      const label = row.label;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      context.font = "14px Microsoft YaHei";
      const width = context.measureText(label).width;
      const sortWidth = row.sort ? 45 : 25;
      return +width.toFixed(0) + sortWidth;
    },
    showTableSet() {
      this.tableColumnSet.visible = true;
      this.tableColumnSet.columnList = this.columnList;
      this.tableColumnSet.checkedList = this.tableData.tableColumn.map(item => item.property);
    },
    getTableColumn() {
      let columnList = localStorage.getItem(this.tableData.api);
      columnList && (columnList = JSON.parse(columnList));
      if (Array.isArray(columnList) && columnList.length) {
        this.tableData.tableColumn = this.columnList.filter(item => columnList.includes(item.property));
      } else {
        this.tableData.tableColumn = this.columnList.filter(item => !item.defaultHide);
      }
    },
    removeColor(list) {
      return list?.map(item => ({id:item.id, msg:item.msg}));
    },
    getRowKeys(row) {
      return row.id;
    },
    selectionChange(list) {
      this.$emit("update:selectList", list);
    },
    expandChange(row, expandedRows) {
      this.expands = [];
      if (expandedRows.length) {
        this.expands.push(row.id);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  line-height: 20px;
}

.table-toolbar {
  margin-bottom: 10px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.operate-bar {
  margin-right: 12px;
}

.icon-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid rgba(148, 163, 184, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.04);
  
  i {
    font-size: 18px;
    color: #64748b;
    transition: all 0.25s ease;
  }
  
  &:hover {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-color: rgba(37, 99, 235, 0.3);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.12);
    transform: translateY(-2px);
    
    i {
      color: #2563eb;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
}

.refresh-btn {
  &:hover i {
    animation: rotate 0.6s ease;
  }
}

.icon-btn {
  &:hover i {
    animation: spin 0.6s ease;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(20deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
